import Clock from "./Clock"
import Entity from "./Entity"
import Level from "./Level"
import Poison, { PoisonEnum } from "./Poison"
import PowerUp, { PowerUpEnum } from "./PowerUp"
import { TILE_SIZE, SCALE_FACTOR } from "./config"
import { getAnimation } from "./spritesheet"

export default class Wall extends Entity {
  static WALL_SIZE = TILE_SIZE * SCALE_FACTOR

  destroyable: boolean

  private _content: PoisonEnum | PowerUpEnum | null = null

  constructor(params: {
    x: number,
    y: number,
    level: Level,
    destroyable: boolean,
    content: PoisonEnum | PowerUpEnum | null,
    blink?: boolean,
  }) {
    super({
      x: params.x,
      y: params.y,
      level: params.level,
      speed: 0,
      width: Wall.WALL_SIZE,
      height: Wall.WALL_SIZE,
      textures: params.destroyable ? getAnimation("wall") : getAnimation("undestroyableWall"),
      staticTileCoords: true,
    })
    this.loop = false
    this.destroyable = params.destroyable
    this._content = params.content
    if (params.blink) {
      this.startBlink(0xffffff)
      Clock.setTimeout(() => {
        this.stopBlink()
      }, 500)
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  isBlocking(_entityConstructor: typeof Entity.constructor): boolean {
    return true
  }

  explode() {
    if (!this.alive) return
    if (this.destroyable) {
      super.explode()
      this.play()
      this.onComplete = () => {
        this.removeFromLevel()
        if (this._content) {
          if (this._content in PowerUpEnum) {
            this.level.addChild(new PowerUp({ x: this.x, y: this.y, level: this.level, type: this._content as PowerUpEnum }))
          } else if (this._content in PoisonEnum) {
            this.level.addChild(new Poison({ x: this.x, y: this.y, level: this.level, type: this._content as PoisonEnum }))
          }
        }
      }
    }
  }

  toString() {
    return "Wall"
  }
}
